import { hot } from "react-hot-loader/root"; //enable ^16.6 react feature(preserve component internal state) for hmr.
import React, { Component } from 'react';
import { Provider } from 'react-redux';
import getStore from '~/redux/store';
import  AppRouter from "~/router/AppRouter";
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import ReactGA from 'react-ga';
import { YMInitializer } from '@am0nshi/react-yandex-metrika';
import {Config} from '~/config';
import {ErrorHandlerComponent} from '@components/layout/error-handler/error-handler.component';
import {CookiesProvider} from 'react-cookie'
import 'react-toastify/dist/ReactToastify.css';
import OneSignal from 'react-onesignal';

if (Config.params.GA_ID) {
    ReactGA.initialize(Config.params.GA_ID);
    ReactGA.pageview(window.location.pathname + window.location.search);
}
if (Config.params.ONESIGNAL) {
    OneSignal.initialize(Config.params.ONESIGNAL, {
        // allowLocalhostAsSecureOrigin: true,
        // autoResubscribe: true,
        // requiresUserPrivacyConsent: true,
        promptOptions: {
            slidedown: {
                enabled: true,
                actionMessage: "Для отправки push-уведомлений необходимо разрешение",
                acceptButtonText: "Разрешить",
                cancelButtonText: "Закрыть",
            }
        }
    });
}

const store = getStore();

class App extends Component {
    render() {
        return (
            <div className="App">
                <ThemeProvider>
                    <Provider store={store}>
                        <CookiesProvider>
                            <ErrorHandlerComponent>
                                <AppRouter/>
                            </ErrorHandlerComponent>
                        </CookiesProvider>
                    </Provider>
                </ThemeProvider>
                { Config.params.METRIKA ? <YMInitializer accounts={[Config.params.METRIKA]} options={{
                    clickmap:true,
                    trackLinks:true,
                    accurateTrackBounce:true,
                    webvisor:true
                }}/> : null }
            </div>
        );
    }
}

export default hot(App);
